import { forwardRef } from "react";
import { useWizard } from "../../hooks/useWizard";
import { ElementContainer } from "./ElementContainer";

export const RadioInput = forwardRef((props, { ref }) => {
    const { setFormValues } = useWizard();
  
    return (
      <ElementContainer {...props}>
        <input
          className={props.styles.input}
          defaultChecked={props.defaultChecked}
          id={props.id}
          name={props.name}
          onChange={(e) => {
            props.setValue(props.name, e.target.value);
            props.setChecked(e.target.value);
            setFormValues(undefined);
          }}
          ref={ref}
          type="radio"
          value={props.id}
        />
      </ElementContainer>
    );
  });